import CreateIcon from '@mui/icons-material/CreateNewFolder';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';

function Option({ addAllOptionsId, hasAddAllOptions, newItemId, option, renderProps }) {
  const { key, ...restRenderProps } = renderProps;
  if (option.id === newItemId) {
    return (
      <Box component="span" key={key} {...restRenderProps}>
        <Stack direction="row" spacing={2} sx={{ color: 'primary.main' }}>
          <CreateIcon />
          <Box>{option.label || ''}</Box>
        </Stack>
      </Box>
    );
  }
  if (hasAddAllOptions && option.id === addAllOptionsId) {
    return (
      <Box component="span" key={key} {...restRenderProps}>
        <Stack direction="row" spacing={2} sx={{ color: 'primary.main' }}>
          <LibraryAddCheckIcon />
          <Box>{option.label || ''}</Box>
        </Stack>
      </Box>
    );
  }
  return (
    <Box component="span" key={key} {...restRenderProps}>
      <Stack direction="row" spacing={1}>
        <Box color="primary.dark" component="span" fontWeight="bold">
          {option.number || ''}
        </Box>
        <Box color={restRenderProps['aria-selected'] ? 'primary.main' : 'text.primary'} component="span">
          {option.name || ''}
        </Box>
      </Stack>
    </Box>
  );
}

Option.propTypes = {
  addAllOptionsId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hasAddAllOptions: PropTypes.bool,
  newItemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  option: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    name: PropTypes.string,
    number: PropTypes.string,
  }).isRequired,
  renderProps: PropTypes.shape({
    'aria-selected': PropTypes.bool,
    key: PropTypes.string,
  }).isRequired,
};

export default Option;
